var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 20H11.6039C11.3039 20 11.0039 19.7 11.0039 19.4V11.6C11.0039 11.3 11.3039 11 11.6039 11H19.4C19.7 11 20 11.3 20 11.6V19.4C20 19.7 19.7 20 19.4 20ZM19 12H12V19H19V12ZM19.4 9H11.6039C11.3039 9 11.0039 8.69999 11.0039 8.39999V0.600006C11.0039 0.300006 11.3039 0 11.6039 0H19.4C19.7 0 20 0.300006 20 0.600006V8.39999C20 8.69999 19.7 9 19.4 9ZM19 1H12V8H19V1ZM8.4 20H0.6141C0.314099 20 0.0140991 19.7 0.0140991 19.4V11.6C0.0140991 11.3 0.314099 11 0.6141 11H8.4C8.7 11 9 11.3 9 11.6V19.4C9 19.7 8.7 20 8.4 20ZM8 12H1V19H8V12ZM8.4 9H0.6141C0.314099 9 0.0140991 8.69999 0.0140991 8.39999V0.600006C0.0140991 0.300006 0.314099 0 0.6141 0H8.4C8.7 0 9 0.300006 9 0.600006V8.39999C9 8.69999 8.7 9 8.4 9ZM8 1H1V8H8V1Z",
    fill: "#818181"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.b1a2f051a89e8c3dc6cd8ccc48096091.svg";
export { ForwardRef as ReactComponent };